import React from 'react';
import PropTypes from 'prop-types';
import colors from '@loggi/ui/components/utils/colors';

const { getViewContainerElement } = __NATIVE__
  ? require('./native')
  : require('./dom');

export default class ViewContainer extends React.Component {
  static displayName = 'ViewContainer';

  static propTypes = {
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object
    ]),
    backgroundColor: PropTypes.oneOf(colors.backgroundHexKeys),
    fluid: PropTypes.bool,
    gutter: PropTypes.bool,
    rowStyle: PropTypes.object,
    rowClassName: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired,
    style: PropTypes.object
  };

  static defaultProps = {
    fluid: false,
    gutter: true,
    rowStyle: {},
    style: null
  };

  render() {
    const {
      backgroundColor,
      fluid,
      gutter,
      className,
      style,
      rowStyle,
      rowClassName,
      children,
      ...otherProps
    } = this.props;

    const classList = [
      { container: !fluid },
      { 'container-fluid': fluid },
      { 'no-gutter': !gutter },
      { [`background-${backgroundColor}`]: backgroundColor }
    ];

    return getViewContainerElement(
      otherProps,
      classList,
      className,
      style,
      rowClassName,
      rowStyle,
      children
    );
  }
}
